<template>
    <div class="home" style="height: calc(100vh - 132px);" ref="appContainer" v-loading="loading">
        <div class="d-b-c">
            <div class="operation-wrap">
                <el-row :gutter="20">
                    <el-col :span="12" :offset="6" class="d-c-c">
                        <div class="sign">
                            <div class="title">请选择考试专业</div>
                            <div>
                                <el-table
                                        :data="tableData"
                                        stripe
                                        :height="maxHeight"
                                        :header-cell-style="{
                                            'font-size': '18px',
                                            'color': '#000'
                                        }"
                                        style="width: 100%;color: black;background-color: #eee">
                                    <el-table-column
                                            prop="major_name"
                                            label="专业名称"
                                            align="center">
                                    </el-table-column>
                                    <el-table-column
                                            prop="fee"
                                            label="报名费（元）"
                                            align="center">
                                    </el-table-column>
                                    <el-table-column
                                            prop="address"
                                            label="操作"
                                            align="center">
                                        <template slot-scope="scope">
                                            <el-button type="text" size="small" @click="enter(scope.row)">进入</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </el-col>
                </el-row>

                <el-row :gutter="20" style="margin-top: 20px">
                    <el-col :span="4" :offset="6" class="d-c-c">
                        <div class="grid-content purple" ref="page" @click="goTo('/admission')">
                            <div class="info">
                                <span class="info-icon icon iconfont menu-item-icon icon-zhunkaozheng"></span>
                                <span>准考证打印</span>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="4" class="d-c-c">
                        <div class="grid-content blue" @click="goTo('/score')">
                            <div class="info">
                                <span class="info-icon icon iconfont menu-item-icon icon-cz-cjdj"></span>
                                <span>成绩查询</span>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="4" class="d-c-c">
                        <div class="grid-content orderred" @click="goTo('/certificate')">
                            <div class="info">
                                <span class="info-icon icon iconfont menu-item-icon icon-wodezhengshu"></span>
                                <span>证书查询</span>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>

        </div>

    </div>
</template>

<script>
    import IndexApi from '@/api/index.js';

    export default {
        data() {
            return {
                loading: true,
                maxHeight: 0,
                tableData: [],
            };
        },
        // 隐藏手机号中间四位
        filters:{
            phoneFilter(val) {
                if(val != null){
                    let reg=/^(.{3}).*(.{4})$/;
                    return val.replace(reg,'$1****$2');
                }
            }
        },
        mounted(){
            this.getMaxHeight()
        },
        created() {
            // 获取数据
            this.getData();
        },
        methods: {
            //获取计算表格高度
            getMaxHeight(){
                this.$nextTick(() => {
                    let appContainer= this.$refs.appContainer.scrollHeight;
                    let page = this.$refs.page.scrollHeight;
                    this.maxHeight = appContainer - page - 76;
                })
            },

            // 获取数据
            getData() {
                let that = this;
                IndexApi.getCount(true).then(res => {
                    that.tableData = res.data.data
                    that.loading = false;
                }).catch(error => {

                });
            },

            // 进入
            enter(row){
                this.$router.push({
                    path: '/major',
                    query: {
                        major_id: row.major_id
                    }
                })
            },

            goTo(url){
                this.$router.push({path: url});
            }

        }
    };
</script>

<style lang="scss" scoped>
    .operation-wrap {
        width: 100%;
        border-radius: 8px;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        overflow: unset;
        background: #fff;
        background-size: 100% 100%;
        color: #FFFFFF;
        margin-bottom: 20px;
        .grid-content {
            width: 100%;
            height: 120px;
            align-items: center;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-direction: row;
            -ms-flex-direction: row;
            flex-direction: row;
            justify-content: center;
            cursor: pointer;
            .info {
                font-size: 32px;
                color: #FFFFFF;
                display: flex;
                align-items: center;
                justify-content: center;
                .info-icon{
                    font-size: 32px;
                    margin-right: 10px;
                }
            }
        }
        .sign{
            width: 100%;
            background-color: #eee;
            border-radius: 15px;
            .title{
                height: 60px;
                width: 100%;
                background-color: #409eff;
                display: flex;
                align-items: center;
                font-size: 18px;
                font-weight: bold;
                color: #fff;
                padding-left: 20px;
                border-top-left-radius: 15px;
                border-top-right-radius: 15px;
            }
        }
        .blue {
            background: url(../../assets/img/total_order.png) no-repeat;
            background-size: 100% 100%;
        }
        .yellow {
            background: url(../../assets/img/total_user.png) no-repeat;
            background-size: 100% 100%;
        }
        .purple {
            background: url(../../assets/img/total_volume.png) no-repeat;
            background-size: 100% 100%;
        }
        .orderred {
            background: url(../../assets/img/total_shop.png) no-repeat;
            background-size: 100% 100%;
        }

        .home-index {
            display: -ms-flexbox;
            display: flex;
            -webkit-box-orient: horizontal;
            -webkit-box-direction: normal;
            -ms-flex-direction: row;
            flex-direction: row;
            -webkit-box-pack: justify;
            -ms-flex-pack: justify;
            justify-content: space-between;
            min-width: 1000px;
            overflow-x: auto;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue